import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Crosshair, Eye, Target } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function Optics() {
  useDocumentMeta('Hunting & Shooting Optics in Lake Benton, Minnesota | Kjergaard Sports', 'Find scopes, binoculars, spotting scopes, rangefinders, and optics options for hunters and target shooters at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Scopes', 'Binoculars', 'Spotting scopes', 'Rangefinders', 'Rifle scopes', 'Shotgun scopes', 'Pistol optics', 'Hunting optics', 'Target shooting optics'];
  return <div data-id="element-609">
      <PageHero title="Hunting & Shooting Optics" image="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="Scopes and optics available at Kjergaard Sports" data-id="element-610" />

      <section className="py-20 bg-brand-offwhite" data-id="element-611">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-612">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-613">
            <div data-id="element-614">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-615">
                Clear Vision for the Field and Range
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-616">
                A quality firearm deserves quality glass. Kjergaard Sports
                carries a wide selection of optics for every application, from
                long-range precision shooting to dense-woods deer hunting.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-617">
                Our knowledgeable staff can help you compare reticles,
                magnification ranges, and glass clarity in person, ensuring you
                select the right optic for your specific needs.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-618">
                <h3 className="font-serif text-xl mb-4" data-id="element-619">
                  Scopes, Binoculars, Rangefinders & More:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-620">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-621">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-622" />
                      <span className="text-brand-charcoal/90" data-id="element-623">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div data-id="element-624">
              <img src="https://cdn.magicpatterns.com/uploads/1zvBEqUZKRM4BZCWhxgmNi/optics-cases.jpg" alt="Optics selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-625" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-626">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-627">
              <Eye className="w-10 h-10 text-brand-hunter mb-4" data-id="element-628" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-629">
                Optics for the Field
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-630">
                Durable, weather-resistant scopes and binoculars designed to
                perform in harsh hunting conditions and low light.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-631">
              <Target className="w-10 h-10 text-brand-hunter mb-4" data-id="element-632" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-633">
                Optics for the Range
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-634">
                High-magnification scopes, spotting scopes, and precision
                reticles for target shooters and long-range applications.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-635">
              <Crosshair className="w-10 h-10 text-brand-hunter mb-4" data-id="element-636" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-637">
                Get In-Person Help
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-638">
                Don't guess based on online specs. Visit the store to look
                through the glass yourself and get practical advice on mounting
                and setup.
              </p>
            </div>
          </div>

          <div className="relative rounded-sm overflow-hidden shadow-lg" data-id="element-639">
            <img src="https://cdn.magicpatterns.com/uploads/kENmASH4b2qj4AE9LqDfT7/mounted-rural-detail.jpg" alt="Rural atmosphere at Kjergaard Sports" className="w-full h-[300px] object-cover" data-id="element-640" />
            <div className="absolute inset-0 bg-brand-charcoal/50 flex items-center justify-center p-8" data-id="element-641">
              <h3 className="text-3xl md:text-4xl font-serif text-brand-offwhite text-center max-w-2xl drop-shadow-md" data-id="element-642">
                Find the Right Glass for Your Next Hunt
              </h3>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-643" />
    </div>;
}